/**
 * @generated SignedSource<<01bb2d02b5177848ecd8852c98c1cf4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type WillBeRecordedNoCacheQuery$variables = {
  eventGuid: string;
};
export type WillBeRecordedNoCacheQuery$data = {
  readonly eventByGuid: {
    readonly willBeRecorded: WillBeRecordedType;
  } | null;
};
export type WillBeRecordedNoCacheQuery = {
  response: WillBeRecordedNoCacheQuery$data;
  variables: WillBeRecordedNoCacheQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventGuid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "eventGuid"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "noCache",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "willBeRecorded",
  "storageKey": "willBeRecorded(noCache:true)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WillBeRecordedNoCacheQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WillBeRecordedNoCacheQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "15719529065c5a9bf56800dc6076c0c7",
    "id": null,
    "metadata": {},
    "name": "WillBeRecordedNoCacheQuery",
    "operationKind": "query",
    "text": "query WillBeRecordedNoCacheQuery(\n  $eventGuid: String!\n) {\n  eventByGuid(guid: $eventGuid) {\n    willBeRecorded(noCache: true)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "92e313a8a2b89554415c70549258003b";

export default node;
